/*
  AAA cart drawer helpers (loaded once from layout/theme.liquid; the drawer itself is re-rendered by AJAX,
  so everything here works through delegated events and a MutationObserver).

  1. Frequency select on cart lines (snippets/aaa-cart-line.liquid): moves every line of the same bundle (same
     _appstle-bb-id, or just that line) to the chosen plan, or to one-time when "One-time purchase" is picked,
     with /cart/change.js, then reloads the drawer. One-time lines can switch to a plan the same way.
  2. Add-on offers (snippets/aaa-cart-offers.liquid renders them from the upsell_offers records): prices each
     offer with the Appstle Bundles rule that covers the cart (its upsell discount for that variant) and, when
     the cart has subscription items, the add-on's plan with the same name; adds it with the rule's properties
     (so Appstle applies the discount) and on that plan (so it ships with the subscription). Shows the biggest
     saving in the note above the cards, and pages through the cards with arrows and dots.
*/
(function () {
  if (window.__aaaCart) return;
  window.__aaaCart = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function parse(x) { if (typeof x !== 'string') return x; try { return JSON.parse(x); } catch (e) { return null; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
  /* X-Appstle-Cart marks these as bundle requests for Appstle's cart script, so it does not rewrite the lines afterwards
     (assets/aaa-cart-reconcile.js enforces the business rules instead). */
  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Appstle-Cart': '1' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); });
  }
  function getCart() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function reloadDrawer() {
    try { if (window.Alpine && Alpine.store('xMiniCart')) Alpine.store('xMiniCart').reLoad(); } catch (e) {}
    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
  }
  function money(cents, fmt) {
    fmt = fmt || '${{amount}}';
    var n = (Number(cents) || 0) / 100;
    var val = function (sep, dec) {
      var parts = n.toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return parts.join(dec);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_with_comma_separator') return val('.', ',');
      if (k === 'amount_no_decimals') return val(',', '.').split('.')[0];
      if (k === 'amount_no_decimals_with_comma_separator') return val('.', ',').split(',')[0];
      return val(',', '.');
    });
  }

  /* ---------- 1. Frequency ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-aaa-freq]');
    if (!sel || sel.disabled) return;
    var name = sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].text.trim() : '';
    var group = sel.getAttribute('data-group');
    var all = Array.prototype.slice.call(document.querySelectorAll('#CartDrawer [data-aaa-freq], #main-cart-items [data-aaa-freq]'));
    /* Every line of the same bundle moves together. The free gift's own select moves only the gift (so it can be
       kept to this order only), and a gift already set to one-time stays one-time when the jars change frequency. */
    var giftSel = sel.hasAttribute('data-gift');
    /* The frequency this line was on (the option Liquid rendered as selected). Only lines of the same bundle that were
       on that same frequency move with it, so a one-time add-on is never pulled into the jars' subscription. */
    var prevOpt = sel.querySelector('option[selected]');
    var prev = prevOpt ? prevOpt.value : '';
    /* Plans are compared by NAME: every product has its own plan ids, so the gift's "Every 2 Months" is a different id
       from the jars' "Every 2 Months" (one-time is ''). */
    var prevName = prev === '' ? '' : (prevOpt.text || '').trim();
    function currentName(s) { var o = s.options[s.selectedIndex]; return s.value === '' ? '' : (o ? o.text.trim() : ''); }
    var targets = all.filter(function (s) {
      if (s === sel) return true;
      if (giftSel || !group || s.getAttribute('data-group') !== group) return false;
      if (s.hasAttribute('data-gift') && s.value === '') return false;
      return currentName(s) === prevName;
    });
    var jobs = [];
    var oneTime = sel.value === '';
    targets.forEach(function (s) {
      var job = { key: s.getAttribute('data-key'), variant: s.getAttribute('data-variant'), fromPlan: s === sel ? prev : s.value, gift: s.hasAttribute('data-gift') };
      if (oneTime) {
        job.selling_plan = null;
        jobs.push(job);
        return;
      }
      var plans = parse(s.getAttribute('data-plans')) || {};
      var planId = s === sel ? sel.value : plans[name];
      var current = s === sel ? null : s.value;
      if (planId && String(planId) !== String(current)) {
        job.selling_plan = Number(planId);
        jobs.push(job);
      }
    });
    all.forEach(function (s) { s.disabled = true; });
    /* Line keys change whenever Appstle re-prices a line and a quantity edit may still be in flight, so every job
       re-reads the cart and targets the line by key, else by variant + plan, with its live quantity. */
    jobs.reduce(function (chain, job) {
      return chain.then(function () {
        return getCart().then(function (cart) {
          var items = cart.items || [];
          var line = items.find(function (l) { return l.key === job.key; }) || items.find(function (l) {
            var pid = l.selling_plan_allocation ? String(l.selling_plan_allocation.selling_plan.id) : '';
            var isG = !!(l.properties && l.properties._appstle_bundle_combo_id === 'progressive_gift');
            return String(l.variant_id) === String(job.variant) && pid === String(job.fromPlan || '') && isG === !!job.gift;
          });
          if (!line) return null;
          return post('cart/change.js', { id: line.key, quantity: line.quantity, selling_plan: job.selling_plan });
        });
      });
    }, Promise.resolve()).catch(function () {}).then(reloadDrawer);
  });

  /* ---------- 2. Add-on offers ---------- */
  function pickRule(rules, cart) {
    var variantIds = cart.filter(function (c) { return !c.gift; }).map(function (c) { return String(c.v); });
    var active = (Array.isArray(rules) ? rules : []).filter(function (r) { return r && r.status === 'ACTIVE'; });
    var covers = active.filter(function (r) {
      return (parse(r.variants) || []).some(function (v) { return variantIds.indexOf(String(v.variantId || v.id)) > -1; });
    });
    /* The rule of the first tagged line that is a bundle item (not an add-on), so add-ons join the main deal. */
    var tagged = cart.filter(function (c) { return c.bb && !c.gift; }).map(function (c) { return c.bb; });
    var byTag = null;
    tagged.some(function (ref) { byTag = covers.find(function (r) { return r.uniqueRef === ref; }) || null; return !!byTag; });
    if (byTag) return byTag;
    var withGift = covers.find(function (r) { if (!r.enableProgressiveGifts) return false; var pg = parse(r.progressiveGift); return pg && Array.isArray(pg.gifts) && pg.gifts.length; });
    return withGift || covers[0] || null;
  }

  function offerPrice(price, up) {
    var d = up ? Number(up.discount) || 0 : 0;
    if (!d) return price;
    if (up.discountType === 'PERCENTAGE') return Math.round(price * (1 - d / 100));
    return Math.max(0, price - Math.round(d * 100));
  }

  function setPanel(box, count) {
    var panel = box.closest('[data-aaa-co-panel]');
    if (panel) panel.hidden = count === 0;
    /* Inline offers (above the checkout button) never widen the drawer. */
    var want = count > 0 && !(panel && panel.hasAttribute('data-aaa-co-inline'));
    /* Widen the drawer for the offers column. The theme (Alpine) may still be setting the refreshed drawer
       up, which resets "show", so set it again a few times. */
    [0, 60, 200, 500, 1000].forEach(function (ms) {
      setTimeout(function () {
        var dialog = document.getElementById('update-cart');
        if (!dialog || !window.Alpine || !Alpine.$data || !dialog._x_dataStack) return;
        try { var data = Alpine.$data(dialog); if (data.show !== want) data.show = want; } catch (e) {}
      }, ms);
    });
  }

  /* The subscription the add-on joins: the plan name of the first subscription line in the cart. For that
     name, the add-on's cheapest plan (when a product sits in two plan groups with the same names). */
  function subPlan(row, planName) {
    if (!planName) return null;
    var best = null;
    (parse(row.getAttribute('data-plans')) || []).forEach(function (p) {
      if (p[0] === planName && (!best || p[2] < best.price)) best = { name: p[0], id: p[1], price: p[2] };
    });
    return best;
  }

  function renderOffers(box) {
    if (box.__aaaDone) return;
    box.__aaaDone = true;
    var rows = Array.prototype.slice.call(box.querySelectorAll('[data-aaa-offer]'));
    setPanel(box, rows.length);
    if (!rows.length) return;
    var rulesEl = box.querySelector('[data-aaa-offers-rules]');
    var rules = parse(rulesEl ? rulesEl.textContent : null);
    if (typeof rules === 'string') rules = parse(rules);
    if (!rules && window._ABConfig) rules = parse(window._ABConfig.bundle_rules);
    var cart = parse(box.getAttribute('data-cart')) || [];
    var rule = cart.length ? pickRule(rules, cart) : null;
    var ups = {};
    if (rule && rule.enableVolumeDiscountUpsell !== false) {
      (parse(rule.upsells) || []).forEach(function (u) { if (u && u.variant) ups[String(u.variant.variantId)] = u; });
    }
    var subLine = cart.find(function (c) { return c.plan && !c.gift; });
    var planName = subLine ? subLine.plan : null;
    var fmt = box.getAttribute('data-money');
    box.__aaaRule = rule;
    box.__aaaRules = Array.isArray(rules) ? rules : [];
    box.__aaaCart = cart;
    box.__aaaUps = ups;
    box.__aaaPlanName = planName;

    var best = 0;
    rows.forEach(function (row) {
      var vid = row.getAttribute('data-variant');
      var price = Number(row.getAttribute('data-price')) || 0;
      var plan = subPlan(row, planName);
      var base = plan ? plan.price : price;
      var sale = offerPrice(base, ups[vid]);
      row.__aaaPlan = plan;
      if (price > 0 && sale < price) best = Math.max(best, Math.round((1 - sale / price) * 100));
      var html = sale < price
        ? '<strong>' + esc(money(sale, fmt)) + '</strong><s>' + esc(money(price, fmt)) + '</s>'
        : '<strong class="is-plain">' + esc(money(price, fmt)) + '</strong>';
      row.querySelector('[data-aaa-offer-price]').innerHTML = html;
    });

    /* "Add now for exclusive savings, up to [percent]% off": the biggest saving among the offers. */
    var note = box.querySelector('[data-aaa-offers-note]');
    var tpl = box.getAttribute('data-note') || '';
    if (note) {
      if (best >= 1 && tpl) {
        note.innerHTML = esc(tpl).replace(/\[percent\](%)?/, function (m, pct) { return '<b>' + best + (pct || '') + '</b>'; });
        note.hidden = false;
      } else {
        note.hidden = true;
      }
    }

    initPager(box, rows.length);
  }

  /* Paging: desktop shows "per page" cards stacked (each grid column is one page), phones a sideways strip of
     single cards. The arrows move one page (desktop) or one card (phones); the dots show where you are. */
  function initPager(box, count) {
    var list = box.querySelector('[data-aaa-offers-list]');
    var nav = box.querySelector('[data-aaa-offers-nav]');
    var dots = box.querySelector('[data-aaa-offers-dots]');
    if (!list || !nav) return;
    var perPage = Math.max(1, Number(box.getAttribute('data-per-page')) || 4);
    list.style.setProperty('--aaa-co-rows', Math.max(1, Math.min(count, perPage)));
    var prev = nav.querySelector('[data-aaa-offers-prev]');
    var next = nav.querySelector('[data-aaa-offers-next]');

    function step() {
      var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      if (getComputedStyle(list).display === 'grid') return list.clientWidth + gap;
      var card = list.querySelector('.aaa-co__item');
      return card ? card.offsetWidth + gap : list.clientWidth;
    }
    function state() {
      var max = list.scrollWidth - list.clientWidth;
      var s = step();
      var pages = max > 2 && s > 0 ? Math.ceil(max / s - 0.05) + 1 : 1;
      var at = max - list.scrollLeft < 2 ? pages - 1 : Math.round(list.scrollLeft / s);
      return { pages: pages, at: Math.min(at, pages - 1), step: s };
    }
    function update() {
      if (!list.clientWidth) return;
      var st = state();
      nav.hidden = st.pages < 2;
      prev.disabled = st.at <= 0;
      next.disabled = st.at >= st.pages - 1;
      if (!dots) return;
      if (dots.children.length !== st.pages) {
        var html = '';
        for (var i = 0; i < st.pages; i++) html += '<button type="button" data-i="' + i + '" aria-label="Offers page ' + (i + 1) + '"></button>';
        dots.innerHTML = html;
      }
      /* At most five dots: a window that follows the current page. */
      var win = 5, start = st.pages > win ? Math.max(0, Math.min(st.at - 2, st.pages - win)) : 0;
      Array.prototype.forEach.call(dots.children, function (d, i) {
        d.setAttribute('aria-current', i === st.at ? 'true' : 'false');
        d.hidden = i < start || i >= start + win;
      });
    }
    function go(i) {
      var st = state();
      i = Math.max(0, Math.min(i, st.pages - 1));
      list.scrollTo({ left: i === st.pages - 1 ? list.scrollWidth : i * st.step, behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { go(state().at - 1); });
    next.addEventListener('click', function () { go(state().at + 1); });
    if (dots) dots.addEventListener('click', function (e) {
      var d = e.target.closest('button[data-i]');
      if (d) go(Number(d.getAttribute('data-i')));
    });
    var raf = 0;
    list.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; update(); });
    }, { passive: true });
    /* Also runs when the phone panel is opened (its size goes from 0) and on resizes. */
    if (window.ResizeObserver) new ResizeObserver(update).observe(list);
    else window.addEventListener('resize', update);
    update();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-aaa-offer-add]');
    if (!btn) return;
    e.preventDefault();
    var box = btn.closest('[data-aaa-offers]');
    var row = btn.closest('[data-aaa-offer]');
    var rule = box && box.__aaaRule;
    var vid = btn.getAttribute('data-aaa-offer-add');
    var errEl = box && box.querySelector('[data-aaa-offers-error]');
    var item = { id: Number(vid), quantity: 1 };
    /* The rule's properties make Appstle apply its add-on discount; only for add-ons that rule lists. */
    if (rule && box.__aaaUps && box.__aaaUps[vid]) {
      /* An add-on already in the cart under a rule tag keeps that tag, so Shopify merges the unit into that line. */
      var same = (box.__aaaCart || []).find(function (c) { return String(c.v) === String(vid) && c.bb && !c.gift; });
      var sameRule = same ? (box.__aaaRules || []).find(function (r) { return r && r.uniqueRef === same.bb; }) : null;
      var tagRule = sameRule || rule;
      item.properties = { '_appstle-bb-id': tagRule.uniqueRef, '__appstle-bb-name': tagRule.name || '', '_appstle_bundles_type': 'VOLUME_DISCOUNT' };
    }
    if (row && row.__aaaPlan) item.selling_plan = Number(row.__aaaPlan.id);
    btn.disabled = true;
    btn.querySelector('span').textContent = box.getAttribute('data-adding');
    if (errEl) errEl.textContent = '';
    post('cart/add.js', { items: [item] }).then(function (res) {
      if (!res.ok) throw new Error((res.d && (res.d.description || res.d.message)) || '');
      reloadDrawer();
    }).catch(function (err) {
      btn.disabled = false;
      btn.querySelector('span').textContent = box.getAttribute('data-add');
      if (errEl) errEl.textContent = (err && err.message) || box.getAttribute('data-error');
    });
  });

  /* Frequency options shortest to longest ("One-time purchase" stays first). */
  function planDays(name) {
    var m = /(\d+)\s*(day|week|month|year)/i.exec(name || '');
    if (!m) return 99999;
    var u = m[2].toLowerCase();
    return Number(m[1]) * (u === 'day' ? 1 : u === 'week' ? 7 : u === 'month' ? 30 : 365);
  }
  function sortFreq(sel) {
    if (sel.__aaaSorted) return;
    sel.__aaaSorted = true;
    var opts = Array.prototype.slice.call(sel.options).filter(function (o) { return o.value !== ''; });
    opts.sort(function (a, b) { return planDays(a.text) - planDays(b.text); }).forEach(function (o) { sel.appendChild(o); });
  }

  /* "Renews at $x" on a subscribed free gift: its plan price less the Appstle add-on discount for that variant
     (renewals keep the add-on discount, not the first-order gift discount). */
  function renderRenew(el) {
    if (el.__aaaDone) return;
    el.__aaaDone = true;
    var drawer = el.closest('#CartDrawer') || document;
    var rulesEl = drawer.querySelector('[data-aaa-offers-rules]');
    var rules = parse(rulesEl ? rulesEl.textContent : null);
    if (typeof rules === 'string') rules = parse(rules);
    var vid = el.getAttribute('data-variant'), ref = el.getAttribute('data-rule') || '';
    var up = null;
    /* The add-on discount of the rule this line is tagged with (that is the one Appstle prices it by); any active
       rule carrying the variant as a fallback. */
    var list = Array.isArray(rules) ? rules : [];
    list.filter(function (r) { return r && String(r.uniqueRef) === ref; }).concat(list).some(function (r) {
      if (!r || r.status !== 'ACTIVE' || r.enableVolumeDiscountUpsell === false) return false;
      up = (parse(r.upsells) || []).find(function (u) { return u && u.variant && String(u.variant.variantId) === vid; }) || null;
      return !!up;
    });
    var fmt = (drawer.querySelector('[data-aaa-offers]') || el).getAttribute('data-money');
    var price = offerPrice(Number(el.getAttribute('data-base')) || 0, up);
    el.textContent = el.getAttribute('data-template').replace('[price]', money(price, fmt));
  }

  function scan() {
    document.querySelectorAll('#CartDrawer [data-aaa-renew], #main-cart-items [data-aaa-renew]').forEach(renderRenew);
    document.querySelectorAll('[data-aaa-offers]').forEach(renderOffers);
    document.querySelectorAll('#CartDrawer [data-aaa-freq], #main-cart-items [data-aaa-freq]').forEach(sortFreq);
  }
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();

  /* ---------- 4. Keep the page still while the drawer is open ----------
     Eurus only puts overflow-hidden on <body>, which iOS Safari ignores, so on phones the page kept scrolling behind
     the open drawer (Jake, 2026-10-22). On touch screens and narrow windows the body is pinned at its scroll offset
     while the drawer is open and put back exactly where it was when it closes. Desktop keeps the theme's own class. */
  (function pageLock() {
    var pinned = false, y = 0;
    var style = document.createElement('style');
    style.textContent = 'html.aaa-cart-lock, html.aaa-cart-lock body { overflow: hidden !important; overscroll-behavior: none; }' +
      ' html.aaa-cart-lock body { position: fixed; left: 0; right: 0; width: 100%; }';
    (document.head || document.documentElement).appendChild(style);
    function narrow() { return window.innerWidth < 1024 || (window.matchMedia && window.matchMedia('(pointer: coarse)').matches); }
    function apply(open) {
      if (open && !pinned) {
        if (!narrow()) return;
        y = window.pageYOffset || document.documentElement.scrollTop || 0;
        document.body.style.top = -y + 'px';
        document.documentElement.classList.add('aaa-cart-lock');
        pinned = true;
      } else if (!open && pinned) {
        document.documentElement.classList.remove('aaa-cart-lock');
        document.body.style.top = '';
        pinned = false;
        var prev = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = 'auto';
        window.scrollTo(0, y);
        document.documentElement.style.scrollBehavior = prev;
      }
    }
    var watching = false;
    function watch() {
      if (watching) return true;
      try {
        if (window.Alpine && Alpine.store('xMiniCart') && Alpine.effect) {
          watching = true;
          Alpine.effect(function () { apply(!!Alpine.store('xMiniCart').open); });
          return true;
        }
      } catch (e) {}
      return false;
    }
    if (!watch()) {
      document.addEventListener('alpine:initialized', watch);
      document.addEventListener('alpine:init', function () { setTimeout(watch, 0); });
    }
  })();
})();
